module.exports = __webpack_public_path__ + "static/fog_giant-06eb3ee6d62ba11bfe6d400d8eb5b6c3.jpeg";